import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=3e6ce461&scoped=true"
import script from "./Alumni.vue?vue&type=script&lang=js"
export * from "./Alumni.vue?vue&type=script&lang=js"
import style0 from "./Alumni.vue?vue&type=style&index=0&id=3e6ce461&prod&lang=scss&scoped=true"
import style1 from "./Alumni.vue?vue&type=style&index=1&id=3e6ce461&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ce461",
  null
  
)

export default component.exports